{
  "name": "client",
  "version": "0.1.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular-material-extensions/select-country": "^17.0.0",
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.9",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/material": "^18.2.9",
    "@angular/material-moment-adapter": "^18.2.10",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@ngrx/effects": "^18.1.0",
    "@ngrx/store": "^18.1.0",
    "@ngrx/store-devtools": "^18.1.0",
    "moment": "^2.30.1",
    "ngx-progressbar": "^11.1.0",
    "ngx-scrollbar": "^15.0.1",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.0",
    "south-african-id-parser": "^2.0.0",
    "svg-country-flags": "^1.2.10",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.9",
    "@angular-eslint/schematics": "^18.4.0",
    "@angular/cli": "^18.2.9",
    "@angular/compiler-cli": "^18.2.0",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.5.2"
  }
}
